import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  toggle() {
    // .debug-panel is a sibling of .message-meta, so we need to go up to .message-content
    const panel = this.element.closest('.message-content').querySelector('.debug-panel')
    if (panel) {
      panel.classList.toggle('hidden')
      this.element.classList.toggle('active')
    }
  }

  async copyJson(event) {
    const button = event.currentTarget
    const promptData = button.dataset.prompt

    try {
      await navigator.clipboard.writeText(promptData)

      // Show feedback
      const originalText = button.innerHTML
      button.innerHTML = `
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
        Copied!
      `
      button.classList.add('copied')

      setTimeout(() => {
        button.innerHTML = originalText
        button.classList.remove('copied')
      }, 2000)
    } catch (err) {
      console.error('Failed to copy:', err)
    }
  }
}
